import React, { useState, useEffect } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { addBlock, updateBlock, setBlocks, setLoading, setError } from '../../../core/data/redux/stateDistrictSlice';
import { addBlock as addBlockService, updateBlock as updateBlockService, fetchBlocks } from '../../../core/data/services/stateDistrictBlockService';
import { Block } from '../../../core/data/types/stateDistrict';

interface BlockFormProps {
  show: boolean;
  onHide: () => void;
  block?: Block;
  stateId: number;
  districtId: number;
  onSuccess: () => void; // callback for success
}

const BlockForm: React.FC<BlockFormProps> = ({ show, onHide, block, districtId, stateId, onSuccess }) => {
  const dispatch = useDispatch();
  const [name, setName] = useState(block?.name || '');

  useEffect(() => {
    if (block) {
      setName(block.name);
    } else {
      setName('');
    }
  }, [block]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      dispatch(setLoading(true));
      let response;
      if (block) {
        const updatedBlock = { id: block.id, name, districtId, stateId };
        response = await updateBlockService(updatedBlock);
        dispatch(updateBlock(response));
      } else {
        response = await addBlockService({ name, districtId, stateId });
        dispatch(addBlock(response));
      }
      // Always refetch full list after mutation and normalize ids to numbers
      const blocks = await fetchBlocks(stateId, districtId);
      const normalized = Array.isArray(blocks)
        ? blocks.map(b => ({ ...b, id: Number(b.id), districtId: Number(b.districtId), stateId: Number(b.stateId) }))
        : [];
      dispatch(setBlocks(normalized));
      setName('');
      onSuccess(); // parent clears selectedBlock and keeps Blocks tab active
      onHide();
    } catch (err: any) {
      dispatch(setError(err.message || 'Failed to save block'));
    } finally {
      dispatch(setLoading(false));
      setName('');

    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{block ? 'Edit Block' : 'Add Block'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Block Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            {block ? 'Update' : 'Add'} Block
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default BlockForm;
